// material-ui
import LinearProgress from "@mui/material/LinearProgress";
// import { styled } from "@mui/material/styles";
import SpinLogo from "../../public/amniverse-ani.svg";
import { red } from "@mui/material/colors";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";

// styles
const LoaderWrapper = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 1301,
  width: "100%",
});

const LoaderSpin = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    max-width: 120px;
    /* margin-top: -60px; */
  }
  /***************************************************
 * Generated by SVG Artista on 8/11/2023, 6:15:47 PM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

  @keyframes animate-svg-fill-1 {
    0% {
      fill: transparent;
    }

    100% {
      fill: rgb(216, 38, 35);
    }
  }

  .svg-elem-1 {
    animation: animate-svg-fill-1 0s cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s
      both;
  }

  @keyframes animate-svg-fill-2 {
    0% {
      fill: transparent;
    }

    100% {
      fill: rgb(226, 82, 80);
    }
  }

  .svg-elem-2 {
    animation: animate-svg-fill-2 0s cubic-bezier(0.55, 0.055, 0.675, 0.19)
      0.08s both;
  }

  @keyframes animate-svg-fill-3 {
    0% {
      fill: transparent;
    }

    100% {
      fill: rgb(229, 99, 97);
    }
  }

  .svg-elem-3 {
    animation: animate-svg-fill-3 0s cubic-bezier(0.55, 0.055, 0.675, 0.19)
      0.16s both;
  }

  @keyframes animate-svg-fill-4 {
    0% {
      fill: transparent;
    }

    100% {
      fill: rgb(216, 38, 35);
    }
  }

  .svg-elem-4 {
    animation: animate-svg-fill-4 0s cubic-bezier(0.55, 0.055, 0.675, 0.19)
      0.24s both;
  }
`;

// ==============================|| LOADER ||============================== //
const Loader = (): React.ReactElement => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
    <LoaderSpin className="spin-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="767.25"
        zoomAndPan="magnify"
        viewBox="0 0 767.25 811.49998"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
      >
        <defs>
          <g></g>
        </defs>
        <path
          fill="#d82623"
          d="M 149.527344 267.445312 C 312.222656 -184.820312 820.773438 152.09375 568.675781 500.324219 C 572.160156 509.613281 573.898438 519.769531 573.898438 530.070312 C 573.898438 578.097656 535.148438 616.839844 487.109375 616.839844 C 439.070312 616.839844 400.320312 578.097656 400.320312 530.070312 C 400.320312 482.042969 439.070312 443.304688 487.109375 443.304688 C 492.042969 443.304688 496.835938 443.449219 501.476562 444.320312 C 644.144531 208.683594 378.113281 -95.003906 184.070312 251.050781 C 172.316406 255.839844 160.703125 261.207031 149.527344 267.445312 Z M 149.527344 267.445312 "
          fillOpacity="1"
          fillRule="nonzero"
          className="svg-elem-1"
        ></path>
        <path
          fill="#e25250"
          d="M 655.902344 310.25 C 966.34375 677.199219 420.058594 949.253906 244.445312 556.914062 C 234.722656 555.171875 225.289062 551.691406 216.289062 546.613281 C 174.78125 522.527344 160.558594 469.566406 184.359375 428.066406 C 208.453125 386.570312 261.71875 372.351562 302.933594 396.148438 C 344.445312 420.085938 358.667969 473.191406 334.863281 514.691406 C 332.542969 519.042969 329.640625 522.816406 326.738281 526.589844 C 459.535156 768.027344 855.75 689.53125 652.851562 348.410156 C 654.59375 335.640625 655.609375 323.019531 655.902344 310.25 Z M 655.902344 310.25 "
          fillOpacity="1"
          fillRule="nonzero"
          className="svg-elem-2"
        ></path>
        <path
          fill="#e56361"
          d="M 365.488281 727.402344 C -107.359375 812.574219 -69.914062 203.75 357.652344 247.859375 C 364.183594 240.3125 371.582031 233.929688 380.726562 228.707031 C 422.234375 204.621094 475.5 218.839844 499.300781 260.335938 C 523.394531 301.832031 509.171875 355.085938 467.664062 378.878906 C 426.152344 402.964844 372.890625 388.601562 349.085938 347.25 C 346.476562 342.894531 344.589844 338.6875 342.847656 334.191406 C 67.238281 328.386719 -62.800781 710.859375 333.992188 705.636719 C 344.152344 713.472656 354.457031 720.726562 365.488281 727.402344 Z M 365.488281 727.402344 "
          fillOpacity="1"
          fillRule="nonzero"
          className="svg-elem-3"
        ></path>
        <g fill="#d82623" fillOpacity="1">
          <g transform="translate(418.745444, 61.050174)">
            <g>
              <path
                d="M 0.140625 0.015625 C 0.109375 0.015625 0.0820312 0.00390625 0.0625 -0.015625 C 0.0507812 -0.0351562 0.046875 -0.0546875 0.046875 -0.078125 C 0.046875 -0.109375 0.0507812 -0.128906 0.0625 -0.140625 C 0.0820312 -0.160156 0.109375 -0.171875 0.140625 -0.171875 C 0.171875 -0.171875 0.195312 -0.160156 0.21875 -0.140625 C 0.238281 -0.128906 0.25 -0.109375 0.25 -0.078125 C 0.25 -0.0546875 0.238281 -0.0351562 0.21875 -0.015625 C 0.195312 0.00390625 0.171875 0.015625 0.140625 0.015625 Z M 0.140625 0.015625 "
                className="svg-elem-4"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </LoaderSpin>
  </LoaderWrapper>
);

export default Loader;
